var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"register-login"},[_c('div',{staticClass:"container"},[_c('Header',{attrs:{"text":_vm.headerText}}),_c('FormRegisterFast',{attrs:{"type":_vm.type}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }